<div id="gc-dg-error">
    <h1>Error</h1>
    <p>Something went wrong</p>
</div>
